export const GenogramConnectionCategoryEnum = Object.freeze({
	EMOTIONAL: "emotional",
	SOCIAL: "social",
	CHILD: "child",
})

const CHILD_CONNECTION_LINE_SUB_TYPES = new Set([
	"straight",
	"adopted",
	"foster",
	"immigration",
	"multicultural",
])

export function normalizeGenogramConnectionCategory(value, fallback = GenogramConnectionCategoryEnum.EMOTIONAL) {
	if(Object.values(GenogramConnectionCategoryEnum).includes(value)){
		return value
	}
	return fallback
}

export function getGenogramConnectionCategoryByLineSubType(lineSubType = "", fallback = GenogramConnectionCategoryEnum.EMOTIONAL) {
	if(typeof lineSubType !== "string" || !lineSubType){
		return fallback
	}
	if(lineSubType.startsWith("family-")){
		return GenogramConnectionCategoryEnum.SOCIAL
	}
	if(CHILD_CONNECTION_LINE_SUB_TYPES.has(lineSubType)){
		return GenogramConnectionCategoryEnum.CHILD
	}
	return fallback
}

export function getGenogramConnectionCategoryByEdgeData(edgeData = {}, fallback = GenogramConnectionCategoryEnum.EMOTIONAL) {
	let storedCategory = normalizeGenogramConnectionCategory(edgeData?.connectionCategory, null)
	if(storedCategory){
		return storedCategory
	}
	return getGenogramConnectionCategoryByLineSubType(edgeData?.lineSubType, fallback)
}

export function isGenogramSocialConnectionCategory(connectionCategory) {
	return normalizeGenogramConnectionCategory(connectionCategory, null) === GenogramConnectionCategoryEnum.SOCIAL
}

